module.exports = __webpack_public_path__ + "static/media/icon_dataset.20a0b1a3.svg";